/**
 * Con qué clave se le enseña un documento a la gente: el código de documento de
 * la caja —«MP-CRE-04»— si lo tiene, porque es por el que lo conocen; si no, la
 * clave del sistema (`DOC-2026-0012`).
 *
 * Es la misma regla que aplica el servidor en correos y reportes
 * (`claveVisible`). Sólo es para mostrar: enlaces, filtros y bitácora siguen
 * yendo por el identificador.
 */
export function claveVisible(documento: { code: string; referenceCode?: string | null }): string {
  return documento.referenceCode || documento.code;
}

/** Lo mismo para una consulta de la bitácora de accesos, que las trae con otro nombre. */
export function claveDeConsulta(entrada: { documentCode: string; documentReferenceCode?: string }): string {
  return claveVisible({ code: entrada.documentCode, referenceCode: entrada.documentReferenceCode ?? null });
}

/** Para buscar: el título y las dos claves, que la gente busca por cualquiera. */
export function textoBuscable(documento: {
  title: string;
  code: string;
  referenceCode?: string | null;
}): string {
  return [documento.title, documento.code, documento.referenceCode ?? ''].join(' ');
}
